import jsPDF from "jspdf";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";

const resolveFontStyle = (fontName: string, style: string) => {
  if (fontName === "Roboto Mono") {
    if (style === "bold") return "bold";
    if (style === "semibold") return "semibold";
    return "normal";
  }

  if (style === "extrabold") return "extrabold";
  if (style === "bold") return "bold";
  if (style === "semibold") return "semibold";
  return "medium";
};

const setFontAuto = (doc: jsPDF, text: string, style: string) => {
  const hasDigit = /[0-9]/.test(text);
  const fontName = hasDigit ? "Roboto Mono" : "Inter";
  doc.setFont(fontName, resolveFontStyle(fontName, style));
};

const tWithFallback = (translate: Function, key: string, fallback: string) => {
  const out = String(translate(key));
  return out === key ? fallback : out;
};

const ellipsisToWidth = (doc: jsPDF, text: string, maxWidth: number) => {
  let out = String(text || "");
  if (!out) return out;
  while (doc.getTextDimensions(out).w > maxWidth && out.length > 4) {
    out = `${out.slice(0, Math.max(0, out.length - 4)).trimEnd()}...`;
  }
  return out;
};

export const TableProductsSectionV3 = (
  params: {
    doc: jsPDF | any;
    bookingType: string;
    accountType: string;
    data: PrintDataEntitas;
    pieceData: any;
    barcode: string;
    vendorRefCode: string;
    barcodeValue: string;
    vendorRefCodeValue: string;
    logo: string;
    shipmentId: string;
    startX: number;
    startY: number;
  },
  translate: Function
) => {
  const left = params.startX + 2;
  const width = 100;
  const startY = params.startY + 107.2;
  const rowHeight = 4.5;
  const nameOffset = 8;
  const qtyX = left + width - 4;
  const variantX = left + width - 23;
  const nameX = left + nameOffset;
  const nameMaxWidth = Math.max(0, variantX - 4 - nameX);
  const variantMaxWidth = Math.max(0, qtyX - 6 - variantX);

  const drawHeader = (yPos: number) => {
    params.doc.setTextColor("#333333");
    params.doc.setFontSize(7);
    setFontAuto(params.doc, "A", "extrabold");

    params.doc.text(tWithFallback(translate, "receipt.productTable.no", "No."), left, yPos);
    params.doc.text(
      tWithFallback(translate, "receipt.productTable.name", "Nama Produk"),
      nameX,
      yPos
    );
    params.doc.text(
      tWithFallback(translate, "receipt.productTable.variant", "Varian"),
      variantX,
      yPos
    );
    params.doc.text(
      tWithFallback(translate, "receipt.productTable.qty", "Qty"),
      qtyX,
      yPos,
      null,
      null,
      "right"
    );

    params.doc.setLineWidth(0.1);
    params.doc.line(left, yPos + 1, left + width, yPos + 1);
    return yPos + 3.5;
  };

  let currentY = drawHeader(startY);
  let counter = 0;

  params.doc.setTextColor("#333333");
  params.doc.setFontSize(6);

  const products = (params.data.sttProducts || []).slice(0, 8);
  for (const p of products) {
    const nextY = currentY + rowHeight;
    counter += 1;

    const nameRaw = ellipsisString(p.productName, 120);
    const variantRaw = p.variant ? ellipsisString(p.variant, 60) : "-";

    setFontAuto(params.doc, String(counter), "semibold");
    params.doc.text(String(counter), left, currentY);

    setFontAuto(params.doc, nameRaw, "semibold");
    const name = ellipsisToWidth(params.doc, nameRaw, nameMaxWidth);
    params.doc.text(name, nameX, currentY);

    setFontAuto(params.doc, variantRaw, "semibold");
    const variant = ellipsisToWidth(params.doc, variantRaw, variantMaxWidth);
    params.doc.text(variant, variantX, currentY);

    setFontAuto(params.doc, String(p.quantity), "semibold");
    params.doc.text(String(p.quantity), qtyX, currentY, null, null, "right");

    params.doc.setLineWidth(0.1);
    params.doc.line(left, currentY + 1.5, left + width, currentY + 1.5);
    currentY = nextY;
  }
};
